import { useSelector } from 'react-redux';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { Collapse, List, ListItemButton, Typography } from '@mui/material';

import LinkList from './LinkList';
import { selectDefaultTheme } from 'GeminiViewerComponent/features/globals/themeSlice';

const ItemList = ({
    index,
    zoneItem,
    item,
    hotspotItem,
    itemSubMenu,
    setItemSubMenu,
    itemProperty,
    linkProperty,
    handleClick,
    handleZoneClick,
    linkKey,
}) => {
    const theme = useSelector(selectDefaultTheme);
    return (
        <List component="div" disablePadding key={index}>
            <ListItemButton
                sx={{ pl: 5 }}
                onClick={(e) => {
                    e.stopPropagation();
                    handleZoneClick(zoneItem, item?.asset_id, hotspotItem);
                }}
            >
                <span style={{ color: theme.colors.text, fontWeight: 'bold' }}>Item:&nbsp;</span>
                <Typography
                    title={hotspotItem[itemProperty]}
                    style={{
                        width: '100%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        margin: '4px 0',
                    }}
                >
                    {hotspotItem[itemProperty]}
                </Typography>
                {itemSubMenu[index] ? (
                    <MdExpandLess
                        className="react-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClick(itemSubMenu, setItemSubMenu, index);
                        }}
                        style={{ fontSize: '28px' }}
                    />
                ) : (
                    <MdExpandMore
                        className="react-icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClick(itemSubMenu, setItemSubMenu, index);
                        }}
                        style={{ fontSize: '28px' }}
                    />
                )}
            </ListItemButton>
            {hotspotItem[linkKey] !== undefined && (
                <Collapse in={itemSubMenu[index]} timeout="auto" unmountOnExit>
                    {hotspotItem[linkKey]?.map((linkItem, idx) => (
                        <LinkList
                            key={`LinkList-${idx}`}
                            zoneItem={zoneItem}
                            hotspotItem={hotspotItem}
                            item={item}
                            linkProperty={linkProperty}
                            handleZoneClick={handleZoneClick}
                            linkItem={linkItem}
                        />
                    ))}
                </Collapse>
            )}
        </List>
    );
};

export default ItemList;
